import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

const MissionVision = () => {
  return (
    <Container>
      <MissionContainer data-aos="fade-up">
        <HeaderContainer>
          <Typography size="6.4rem" m_size="4rem" weight="semibold">
            Our
          </Typography>
          <Typography size="6.4rem" m_size="4rem" weight="semibold">
            Mission
          </Typography>
          <HeaderDashContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 80 8"
              fill="none"
            >
              <path
                d="M2 1.34412H78M13.7412 6.57494H65.213M14.0688 6.57494L58.82 1.47059"
                stroke="#FEB73D"
                stroke-width="2.20215"
                stroke-linecap="round"
              />
            </svg>
          </HeaderDashContainer>
        </HeaderContainer>
        <Typography
          size="xl"
          m_size="m"
          m_lh="2.4"
          color={Colors.grey400}
          lh="2.8"
        >
          To empower African creators with the tools they need to share their
          art globally. We believe in the power of African music and stories,
          and our mission is to give creators a dedicated platform for
          distribution, recognition, and fair compensation. Rated Afrika is
          built for Africa, by Africans, and designed to amplify African voices
          on a global stage."
        </Typography>
      </MissionContainer>
      <VisionContainer data-aos="fade-up">
        <HeaderContainer>
          <RightArrowSvg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 42 98"
              fill="none"
            >
              <path
                d="M32.889 2.22054C32.7673 1.37599 33.3532 0.592626 34.1977 0.470841C35.0423 0.349058 35.8256 0.934969 35.9474 1.77951L32.889 2.22054ZM1.22658 93.2261C0.405802 92.9929 -0.0704938 92.1384 0.162753 91.3176L3.96371 77.9422C4.19696 77.1214 5.05141 76.6451 5.8722 76.8784C6.69298 77.1116 7.16927 77.9661 6.93603 78.7869L3.55739 90.6761L15.4467 94.0548C16.2674 94.288 16.7437 95.1425 16.5105 95.9632C16.2772 96.784 15.4228 97.2603 14.602 97.0271L1.22658 93.2261ZM20.0959 67.5542L18.554 67.6522L18.5487 67.5687L18.5524 67.4851L20.0959 67.5542ZM33.5672 24.5202L34.722 25.5466L33.5672 24.5202ZM39.4442 49.1507L40.8799 48.5801L39.4442 49.1507ZM22.6469 46.0317L23.9768 45.2453L22.6469 46.0317ZM23.6469 35.6809L24.8017 36.7074L23.6469 35.6809ZM23.9768 45.2453L28.3523 52.6453L25.6924 54.2181L21.3169 46.818L23.9768 45.2453ZM38.1661 50.1181L38.0084 49.7212L40.8799 48.5801L41.0377 48.977L38.1661 50.1181ZM21.675 57.8402C21.7813 60.9266 21.7912 64.2322 21.6394 67.6234L18.5524 67.4851C18.7001 64.1881 18.6908 60.9651 18.5869 57.9465L21.675 57.8402ZM21.6378 67.4563C22.0358 73.7226 19.1959 79.024 15.3482 83.258C11.5059 87.4861 6.55033 90.7766 2.40115 93.0895L0.896671 90.3904C4.90935 88.1537 9.53958 85.0553 13.0615 81.1799C16.5779 77.3103 18.8806 72.7938 18.554 67.6522L21.6378 67.4563ZM35.9474 1.77951L37.8652 15.0787L34.8068 15.5197L32.889 2.22054L35.9474 1.77951ZM34.722 25.5466L24.8017 36.7074L22.4922 34.6545L32.4125 23.4937L34.722 25.5466ZM35.3269 47.1197C28.7244 44.7248 21.4227 50.5114 21.675 57.8402L18.5869 57.9465C18.27 48.7444 27.4337 40.9695 36.3806 44.2149L35.3269 47.1197ZM37.8652 15.0787C38.4105 18.8607 37.2605 22.6906 34.722 25.5466L32.4125 23.4937C34.3462 21.3182 35.2222 18.4007 34.8068 15.5197L37.8652 15.0787ZM36.3806 44.2149C38.4352 44.9602 40.0728 46.549 40.8799 48.5801L38.0084 49.7212C37.5273 48.5108 36.5514 47.5639 35.3269 47.1197L36.3806 44.2149ZM28.3523 52.6453C31.1497 57.3765 38.417 55.1326 38.0601 49.6479L41.1436 49.4472C41.7116 58.1767 30.1449 61.7482 25.6924 54.2181L28.3523 52.6453ZM21.3169 46.818C19.0234 42.939 19.4984 38.0226 22.4922 34.6545L24.8017 36.7074C22.7003 39.0716 22.3668 42.5225 23.9768 45.2453L21.3169 46.818Z"
                fill="#FEB73D"
              />
            </svg>
          </RightArrowSvg>
          <Typography size="6.4rem" m_size="4rem" weight="semibold">
            Our
          </Typography>
          <Typography size="6.4rem" m_size="4rem" weight="semibold">
            Vision
          </Typography>
          <LeftArrowSvg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 42 98"
              fill="none"
            >
              <path
                d="M8.54846 95.8355C8.67025 96.68 8.08434 97.4634 7.23979 97.5852C6.39525 97.707 5.61188 97.1211 5.4901 96.2765L8.54846 95.8355ZM40.2109 4.82992C41.0317 5.06317 41.508 5.91763 41.2747 6.73841L37.4738 20.1138C37.2405 20.9346 36.3861 21.4109 35.5653 21.1777C34.7445 20.9444 34.2682 20.0899 34.5015 19.2692L37.8801 7.37991L25.9908 4.00128C25.1701 3.76803 24.6938 2.91358 24.927 2.0928C25.1603 1.27201 26.0147 0.795718 26.8355 1.02897L40.2109 4.82992ZM21.3416 30.5018L22.8835 30.4038L22.8888 30.4873L22.8851 30.5709L21.3416 30.5018ZM7.87027 73.5359L6.7155 72.5095L7.87027 73.5359ZM1.99335 48.9054L0.557569 49.4759L1.99335 48.9054ZM18.7906 52.0244L17.4607 52.8107L18.7906 52.0244ZM17.7906 62.3751L16.6358 61.3487L17.7906 62.3751ZM17.4607 52.8107L13.0852 45.4107L15.7451 43.838L20.1206 51.238L17.4607 52.8107ZM3.2714 47.9379L3.42913 48.3348L0.557569 49.4759L0.399846 49.0791L3.2714 47.9379ZM19.7625 40.2158C19.6562 37.1295 19.6463 33.8238 19.7981 30.4327L22.8851 30.5709C22.7374 33.8679 22.7467 37.0909 22.8506 40.1095L19.7625 40.2158ZM19.7997 30.5997C19.4017 24.3335 22.2416 19.032 26.0893 14.798C29.9316 10.57 34.8872 7.27942 39.0363 4.96658L40.5408 7.66558C36.5282 9.90233 31.8979 13.0007 28.376 16.8762C24.8596 20.7457 22.5569 25.2623 22.8835 30.4038L19.7997 30.5997ZM5.4901 96.2765L3.57232 82.9773L6.63069 82.5363L8.54846 95.8355L5.4901 96.2765ZM6.7155 72.5095L16.6358 61.3487L18.9453 63.4015L9.02504 74.5623L6.7155 72.5095ZM6.11064 50.9363C12.7131 53.3313 20.0148 47.5446 19.7625 40.2158L22.8506 40.1095C23.1675 49.3116 14.0038 57.0865 5.05694 53.8411L6.11064 50.9363ZM3.57232 82.9773C3.02696 79.1954 4.17699 75.3654 6.7155 72.5095L9.02504 74.5623C7.0913 76.7378 6.21525 79.6554 6.63069 82.5363L3.57232 82.9773ZM5.05694 53.8411C3.00232 53.0958 1.36474 51.5071 0.557569 49.4759L3.42913 48.3348C3.91018 49.5453 4.88614 50.4921 6.11064 50.9363L5.05694 53.8411ZM13.0852 45.4107C10.2878 40.6796 3.02048 42.9235 3.37736 48.4082L0.293886 48.6088C-0.274128 39.8793 11.2926 36.3078 15.7451 43.838L13.0852 45.4107ZM20.1206 51.238C22.4141 55.117 21.9391 60.0334 18.9453 63.4015L16.6358 61.3487C18.7372 58.9845 19.0707 55.5335 17.4607 52.8107L20.1206 51.238Z"
                fill="#FEB73D"
              />
            </svg>
          </LeftArrowSvg>
        </HeaderContainer>
        <Typography
          size="xl"
          m_size="m"
          m_lh="2.4"
          color={Colors.grey400}
          lh="2.8"
        >
          We envision an Africa where every artist has the opportunity to be
          heard, valued, and celebrated on a global scale. Our goal is to
          continue expanding Rated Afrika’s reach, growing our network of
          partnerships, and developing even more tools to support African
          creators.
        </Typography>
      </VisionContainer>
      <OurStoryContainer data-aos="fade-up">
        <HeaderContainer>
          <Typography size="6.4rem" m_size="4rem" weight="semibold">
            Our Story
          </Typography>
          <StarSvg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 141 135"
              fill="none"
            >
              <path
                d="M69.2468 3.12102C69.6413 1.90702 71.3587 1.90702 71.7532 3.12102L86.504 48.5193C87.0332 50.1481 88.551 51.2508 90.2636 51.2508L137.998 51.2508C139.275 51.2508 139.805 52.8842 138.773 53.6345L100.155 81.6922C98.7691 82.6989 98.1893 84.4831 98.7186 86.1119L113.469 131.51C113.864 132.724 112.474 133.734 111.442 132.983L72.8235 104.926C71.438 103.919 69.562 103.919 68.1765 104.926L29.5583 132.983C28.5257 133.734 27.1362 132.724 27.5306 131.51L42.2814 86.1119C42.8107 84.4831 42.2309 82.6989 40.8454 81.6922L2.2273 53.6345C1.19461 52.8842 1.72534 51.2508 3.00181 51.2508L50.7364 51.2508C52.449 51.2508 53.9668 50.1481 54.496 48.5193L69.2468 3.12102Z"
                stroke="#FEB73D"
                stroke-width="2.63536"
              />
            </svg>
          </StarSvg>
        </HeaderContainer>
        <Typography
          size="xl"
          m_size="m"
          m_lh="2.4"
          color={Colors.grey400}
          lh="2.8"
        >
          From our founders' own experiences navigating the complexities of the
          music industry as an independent artist “Rated Afrika” was born.
          Frustrated by the barriers to entry and lack of transparency, we set
          out to create a solution that would level the playing field. In 2024,
          the team assembled and began building the RatedAfrika platform. Our
          goal was to simplify music distribution while providing artists with
          the tools and insights needed to grow their careers. Through tireless
          effort and a deep understanding of the challenges facing independent
          creators, RatedAfrika has evolved into a trusted partner for artists
          around the world.
        </Typography>
      </OurStoryContainer>
    </Container>
  );
};

export default MissionVision;

const Container = styled.div`
  padding: 12.7rem 10.4rem;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    gap: 4.4rem;
    padding: 4.8rem 2rem;
  }
`;
const HeaderContainer = styled.div`
  position: relative;
  margin-bottom: 2rem;
  width: fit-content;
  @media only screen and (max-width: 769px) {
    display: flex;
    gap: 2rem;
    margin-bottom: 1rem;
  }
`;

const MissionContainer = styled.div`
  width: 40%;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const HeaderDashContainer = styled.div`
  position: absolute;
  height: 0.8rem;
  width: 10rem;
  left: 4rem;
  bottom: 0.5rem;
  @media only screen and (max-width: 769px) {
    width: 10rem;
    bottom: 0.2rem;
    left: unset;
    right: 3rem;
  }
`;

const VisionContainer = styled.div`
  width: 40%;
  margin-left: auto;
  margin-top: -12rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-top: unset;
  }
`;
const LeftArrowSvg = styled.div`
  position: absolute;
  left: -8rem;
  width: 6rem;
  height: 8.4rem;
  bottom: -4rem;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const RightArrowSvg = styled.div`
  position: absolute;
  right: 0rem;
  width: 6rem;
  height: 8.4rem;
  top: -4rem;
  @media only screen and (max-width: 769px) {
    width: 4.3rem;
    height: 6rem;
    right: -4rem;
    top: -2rem;
  }
`;

const OurStoryContainer = styled.div`
  width: 100%;
  margin-top: 5.5rem;
`;

const StarSvg = styled.div`
  position: absolute;
  width: 14rem;
  height: 14rem;
  top: -4rem;
  right: 0;
  z-index: -1;
  @media only screen and (max-width: 769px) {
    width: 5rem;
    height: 5rem;
    right: -6rem;
    top: 0rem;
  }
`;
